import { sanityDataset, sanityImagesBaseUrl, sanityProjectId } from '../sanity.io/config';

export const GOOGLE_MAPS_API = process.env.REACT_APP_GOOGLE_MAPS_API;
export const HOSTFULL_API = process.env.REACT_APP_HOSTFULL_API;
export const X_HOSTFULLY_APIKEY = process.env.REACT_APP_X_HOSTFULLY_APIKEY;
export const AGENCY_UID = process.env.REACT_APP_AGENCY_UID;

export const BACKEND_API = process.env.REACT_APP_BACKEND_API;
export const BASE_SANITY_IMAGE_URL = `${sanityImagesBaseUrl}/${sanityProjectId}/${sanityDataset}/`;
export const PAYMENT_METHOD_REDIRECT = 'redirect';
export const SOCIAL_NETWORKS = ['facebook', 'instagram'];
export const OPEN_SIGNUP_FLAG = 'openSignUp';
